import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import PropTypes from 'prop-types';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, FormControlLabel,  
  Grid, InputLabel, Radio, RadioGroup, Snackbar, SnackbarContent, TextField, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AppBindStyles from '../../AppBindStyles';
import SavingSpinner from '../ui/SavingSpinner';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

import classNames from 'classnames';


const abEnvironment = new AbEnvironment();
const StepProjectSelectionQuery = graphql`
query StepProjectSelectionQuery($accountId: UUID!) {
  allProjectTs(condition: { customerAccountId: $accountId, projectStatus: 0}) {
    totalCount
    nodes {
      projectId
			projectName
      projectStatus
      resellerWalletId
      resellerAccountId
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  accountLogo: {
    float: 'left',
    marginRight: 15
  },
  button: {
    width: 52,
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});


class StepProjectSelection extends React.Component {
  
  state = {
    users: null,
    projectSelected: null,
    createNewProject: false,
    projectName: null,

    saveStatus: null,
    saveMessage: null,
    snackbarOpen: false,
    snackbarDuration: null,
    forceFetch: 0
  }

  componentDidMount() {

    //console.log(this.props.project);
  }


  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    return false;
  }

  isNextDisabled(props) {

    if (this.props.activeStep === this.props.assignedStep) {
      
      if (this.state.createNewProject) {
        return this.disableProjectSave();
      } else if (props.allProjectTs.totalCount === 0) {
        return true;
      }
      return false;
      
    }
    return false;
  }



  handleSnackbarClose = (event, reason) => { 
    this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
  };


  handleProjectChange(event, props) {

    let projectId = event.target.value;

    if (projectId === '0') {
      //user wants to create a new project.
      this.setState( {createNewProject: true, projectSelected: null, projectName: null} );
      return;
    }


    let projectSelected = null;
    let i = 0;
    for (i = 0; i < props.allProjectTs.nodes.length; i++) {
      let project = props.allProjectTs.nodes[i];
      if (project.projectId === projectId) {
          projectSelected = project;
      }
    }

    if (projectSelected) {

      this.setState({saveDisabled: false, projectSelected: projectSelected, createNewProject: false});
      this.props.setProjectStateChanged(projectSelected);
    }
  
  }

  disableProjectSave(props) {

    if (!this.state.projectName)
      return true;

    return false;
  }

  handleNext(props) {
    //make sure at a project is selected
    if (!this.state.projectSelected) {
      let firstProject = props.allProjectTs.nodes[0];

      this.setState({saveDisabled: false, projectSelected: firstProject, createNewProject: false});
      this.props.setProjectStateChanged(firstProject);
    }


    this.props.handleNext();
  }

  getProjectSelectedValue(props) {
    if (this.state.createNewProject === true) {
      return 0;
    } else if (this.state.projectSelected) {
      return this.state.projectSelected.projectId;
    } else if (props.allProjectTs.totalCount === 1) {
      return props.allProjectTs.nodes[0].projectId;
    } else {
      return null;
    }
  }

  render() {

    const { logError } = this.props.auth;
    const classes = this.props.classes;

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    }

    let acctId = this.props.customer.accountId;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={StepProjectSelectionQuery}
        variables={{accountId: acctId, forceFetch: this.state.forceFetch}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {


           /* if (!this.state.usersLoaded) {
              //componentDidMount not finished
              return (
                <div className={classes.root}>
                  <Grid container direction="column" justifyContent="center">
                    <Grid item>
                      <Grid container spacing={0} direction="row" justifyContent="center" className={classes.spinny}>
                        <Grid item>
                          <CircularProgress color="primary" size={75} thickness={2}/>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              );
            }*/


 
            let allowNewProject = true;
            /*if (this.props.customer.customerStatus && this.props.customer.customerStatus === 2) {
              allowNewProject = false;
            }*/

            if (!displayOnly) {

              if (props.allProjectTs.nodes.length > 0) {

                let counter = 1;

                return (
                  <Grid container spacing={1} >

                    <Grid item xs={12}>
                      <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup aria-label="project" name="project" value={this.getProjectSelectedValue(props)} onChange={(e) => this.handleProjectChange(e, props)}>

                        { props.allProjectTs.nodes.map(n => {

                          return (<FormControlLabel  key={(counter++).toString()}
                              value={n.projectId}
                              control={<Radio />} 
                              label={<Typography variant="body2"><b>{n.projectName} {n.projectStatus === 0 ? '(in progress)' : '(closed)'}</b></Typography>}
                            />);
                          })}

                          {allowNewProject &&
                          <FormControlLabel  key={(counter++).toString()}
                              value={0}
                              control={<Radio />} 
                              label={<Typography variant="body2"><b>{'Create new project'}</b> </Typography>}
                              />
                          }

                        </RadioGroup>
                      </FormControl>
                      {this.state.createNewProject === true &&
                        <Grid container spacing={2} >
                        <Grid item xs={12} sm={6}>
                          <TextField 
                            id="project-name" label="Project name"
                            value={this.state.projectName}
                            onChange={(e) => this.setState({ projectName: e.target.value })}
                            inputProps={{ maxLength: 32 }}
                          />
                        </Grid>

                        <Snackbar
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          open={this.state.snackbarOpen}
                          autoHideDuration={this.state.snackbarDuration}
                          onClose={this.handleSnackbarClose}
                        >
                          <SnackbarContent
                            className={classNames(classes.message, classes[this.state.saveStatus])}
                            onClose={this.handleSnackbarClose}
                            message={
                              <Typography variant="body1">
                                  {this.state.saveMessage}
                              </Typography>
                            }
                            action={[
                              <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                className={classes.close}
                                onClick={this.handleSnackbarClose}
                                size="large">
                                <CloseIcon />
                              </IconButton>
                            ]}
                          />
                        </Snackbar>

                        {this.props.activeStep === this.props.assignedStep && false &&
                        <Grid item xs={12}>
                          <Button
                            disabled={this.isBackDisabled()}
                            color="primary" variant="outlined"
                            onClick={() => this.props.handleBack()}
                            style={AppBindStyles.bottomButton}>
                            Back
                          </Button>

                          {this.state.saveStatus !== 'saving' &&
                          <Button
                            color="primary" variant="contained"
                            disabled={this.disableProjectSave()}
                            onClick={() => { this.createProject(acctId);}}
                            style={AppBindStyles.bottomButton}>
                              Next
                          </Button>
                          }

                          {this.state.saveStatus === 'saving' &&
                          <Button
                            color="primary" variant="contained"
                            style={AppBindStyles.bottomButton}>
                              <SavingSpinner/>
                          </Button>
                          }
                        </Grid>}
                      </Grid>
                    }
                    </Grid>

                    {this.props.activeStep === this.props.assignedStep &&
                    <Grid item xs={12}>
                      <Button
                        disabled={this.isBackDisabled()}
                        color="primary" variant="outlined"
                        onClick={() => this.props.handleBack()}
                        style={AppBindStyles.bottomButton}>
                        Back
                      </Button>

                      {this.state.saveStatus !== 'saving' &&
                      <Button
                        color="primary" variant="contained"
                        disabled={this.isNextDisabled(props)}
                        onClick={() => { this.determineNextStep(acctId, props);}}
                        style={AppBindStyles.bottomButton}>
                          Next
                      </Button>
                      }
                      {this.state.saveStatus === 'saving' &&
                        <Button
                          color="primary" variant="contained"
                          style={AppBindStyles.bottomButton}>
                            <SavingSpinner/>
                        </Button>
                      }
                    </Grid>
                    } 
                  </Grid>
                );
              } else {
                //no projects exist
      
                return (
                  <Grid container spacing={2} >
                    <Grid item xs={12} sm={6}>
                      <TextField 
                        id="project-name" label="Project name"
                        value={this.state.projectName}
                        onChange={(e) => this.setState({ lastName: e.target.value })}
                        inputProps={{ maxLength: 32 }}
                      />
                    </Grid>
                    

                    <Snackbar
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      open={this.state.snackbarOpen}
                      autoHideDuration={this.state.snackbarDuration}
                      onClose={this.handleSnackbarClose}
                    >
                      <SnackbarContent
                        className={classNames(classes.message, classes[this.state.saveStatus])}
                        onClose={this.handleSnackbarClose}
                        message={
                          <Typography variant="body1">
                              {this.state.saveMessage}
                          </Typography>
                        }
                        action={[
                          <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className={classes.close}
                            onClick={this.handleSnackbarClose}
                            size="large">
                            <CloseIcon />
                          </IconButton>
                        ]}
                      />
                    </Snackbar>

                    {this.props.activeStep === this.props.assignedStep &&
                    <Grid item xs={12}>
                      <Button
                        disabled={this.isBackDisabled()}
                        color="primary" variant="outlined"
                        onClick={() => this.props.handleBack()}
                        style={AppBindStyles.bottomButton}>
                        Back
                      </Button>

                      {this.state.saveStatus !== 'saving' &&
                      <Button
                        color="primary" variant="contained"
                        disabled={this.disableProjectSave()}
                        onClick={() => { this.createProject(acctId);}}
                        style={AppBindStyles.bottomButton}>
                          Next
                      </Button>
                      }

                      {this.state.saveStatus === 'saving' &&
                      <Button
                        color="primary" variant="contained"
                        style={AppBindStyles.bottomButton}>
                          <SavingSpinner/>
                      </Button>
                      }
                    </Grid>}
                  </Grid>
                );
              }
            } else {

              //display only
              return (
        
                <Grid container >
                  
                <Grid item xs={12}>
                  <InputLabel shrink style={{marginBottom:6}}>Project</InputLabel>
                  <Typography variant="body1" style={AppBindStyles.boldLabel}>
                    {this.props.project.projectName}
                  </Typography>
                </Grid>
              </Grid>
     
           
              );
        
            }
          }
          if (!displayOnly) {
            return <div><LoadingSpinner/></div>
          }
        }
      }
      />
    );

  }

  determineNextStep = (accountId, props) => {
    if (this.state.createNewProject) {
      this.createProject(accountId);
    } else {
      this.handleNext(props);
    }

  }

  createProject = (accountId) => {
    this.setState({ saveStatus: 'saving' });
    const { projectName } = this.state;
    const { callPartnerApi } = this.props.auth;

    let forceFetch = this.state.forceFetch;
    forceFetch++;

    let pAccountId = abEnvironment.getUserAttribute('a_id');
    let aPjwt = abEnvironment.getPjwt();
    let success = false;

    let payload = {
      operation: "createProject",
      params: {
        pJwt: aPjwt,
        'accountId': accountId,
        'pAccountId': pAccountId,
        'projectName': projectName
}
    }

    callPartnerApi('appbind/generic',
      'POST',
      payload
    )
    .then((response) => {
      if (response.status === 200) {
        success = true;
      }
      return response.json();
      /*response.json().then(data => {
        // do something with your data
        console.log(data);
       let errorObj = {
        'error': { errMessage : data.errMessage }
        }
       throw(errorObj);
      });*/
      
    
      
    })
    .then((response) => {
      //console.log(JSON.stringify(response));
      if (success) {
        //set up a user object in memory
        let project = response.data.projectTByProjectId;


        this.setState({saveDisabled: false, saveStatus: null, projectSelected: project, createNewProject: false, forceFetch: forceFetch});
        
        this.props.setProjectStateChanged(project);
        this.props.handleNext();
      } else {
        //sort of a hack to have this here.
        let theMessage = 'Unable to create project'
        if (response.errMessage != null)
        {
          theMessage = response.errMessage;
        }
        this.setState({ snackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
      }
    })
    .catch(error => {
      let theMessage = 'Unable to create project'
      if (error.errMessage != null)
      {
        theMessage = error.errMessage;
      }
      this.setState({ snackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
    });
  }


}


StepProjectSelection.propTypes = {
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(StepProjectSelection);
